import { useRef } from 'react';
import { Scrollbar, Mousewheel, FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperClass } from 'swiper/types';
import { useTranslation } from 'next-i18next';
import styles from '@features/showrooms/sections/ShowroomsSection/Components/ServiceFiltersInfo/ServiceFiltersInfo.styles';
import Heading from '@components/Heading/Heading';
import Icon from '@components/icons/Icon';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/scrollbar';
const ServiceFiltersInfo = () => {
  const {
    t
  } = useTranslation('common');
  const swiperInstance = useRef<SwiperClass>(null);
  return <div sx={styles.container}>
      <Heading h={2} size={24} uppercase pb={24} mobile>
        {t('shoowroomMapFilters.filtersService')}
      </Heading>
      <Swiper direction="vertical" modules={[Scrollbar, Mousewheel, FreeMode]} scrollbar={{
      draggable: true,
      hide: false,
      dragSize: 80
    }} onSwiper={swiper => {
      swiperInstance.current = swiper;
    }} followFinger slidesPerView="auto" freeMode mousewheel>
        <SwiperSlide>
          <div sx={styles.item}>
            <Icon icon="FreeInteriorDesign" size="64px" />
            <Heading h={1} size={18} uppercase pb={8} mobile>
              {t('shoowroomMapFilters.freeInteriorDesign')}
            </Heading>
            <span>{t('shoowroomMapFilters.freeInteriorDesignDescription')}</span>
          </div>
          <div sx={styles.item}>
            <Icon icon="DesignInVoxboxVr" size="64px" />
            <Heading h={1} size={18} uppercase pb={8} mobile>
              {t('shoowroomMapFilters.designInVoxboxVR')}
            </Heading>
            <span>{t('shoowroomMapFilters.designInVoxboxVRDescription')}</span>
          </div>
          <div sx={styles.item}>
            <Icon icon="MaterialLibrary" size="64px" />
            <Heading h={1} size={18} uppercase pb={8} mobile>
              {t('shoowroomMapFilters.materialLibrary')}
            </Heading>
            <span>{t('shoowroomMapFilters.materialLibraryDescription')}</span>
          </div>
          <div sx={styles.item}>
            <Icon icon="ArchitectZone" size="64px" />
            <Heading h={1} size={18} uppercase pb={8} mobile>
              {t('shoowroomMapFilters.architectZone')}
            </Heading>
            <span>{t('shoowroomMapFilters.architectZoneDescription')}</span>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>;
};
export default ServiceFiltersInfo;